import Filter from "./filter_controller.js"
import Programs from "./programs_controller.js"
import Tags from "./tags_controller.js"
import Sort from "./sort_controller.js"
import Adaptive from "./found_directions/adaptive_controller.js"

export function registerControllers() {
  window.Stimulus.register('filter', Filter)
  window.Stimulus.register('programs', Programs)
  window.Stimulus.register('tags', Tags)
  window.Stimulus.register('sort', Sort)
  window.Stimulus.register('adaptive', Adaptive)
}
